import getMobileOperatingSystem from "./getMobileOperationSystem";
import {IConstants} from "../mainscreen/model/B2CInfo";

export interface MobileAppPromo {
    link: string
    icon: string
}

export function getMobileAppPromo(constants: IConstants): MobileAppPromo {
    let platform = getMobileOperatingSystem()
    let icon: string
    let link: string = "https://6lg6.adj.st/?adjust_t=d3pt85v"
    if (platform === "ios") {
        icon = constants.app_store_icon
    } else {
        icon = constants.google_play_icon
    }
    return {
        link: link,
        icon: icon
    }
}